import React from 'react';
import TextArea from '../../forms/TextArea';
import FormSetting from '../../layout/FormSetting';
import { QuestRoute } from '../../api/QuestRoutes';
import PageBreak from '../../layout/PageBreak';
import HamQuest from '../../api/HamQuestGiver';
import { generateId } from '../../utility/functions';
import GetState from '../../GetState';
import Form from '../../forms/Form';
import Input from '../../forms/Input';
import Button from '../../forms/Button';
import LoadingEllipsis from '../../forms/LoadingEllipsis';
import Col from '../../layout/Col';
import Row from '../../layout/Row';
import Select from '../../forms/Select';
import Heading from '../../forms/Heading';
import Loading from '../../Loading';
import { userRoles } from '../../RoleProtected';
import ModalFactory from '../../Modal';

const Messaging = ({ children, ...props }) => {

    const [messages, fetchMessages] = GetState(QuestRoute.expressPass.messages)
    const [assignments, fetchAssignments] = GetState(QuestRoute.expressPass.messageAssignments)

    const addNewMessage = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: 'Add New Message',
            body: (
                <Form
                    inputs={{
                        messageId: '',
                        message: '',
                        messageName: ''
                    }}
                    onSubmit={e => HamQuest.post(QuestRoute.expressPass.messages, e)
                        .then(() => {
                            ModalFactory.close(id);
                            fetchMessages();
                        })}
                >
                    <Input
                        name='messageName'
                        label='Name'
                        required
                    />
                    <TextArea
                        label='Message'
                        name='message'
                        tags={['FirstName', 'LastName', 'FullName', 'PassProgram']}
                        required
                    />
                </Form>
            )
        })
    }

    const Messages = () => {
        const options = [
            {
                value: '',
                label: ''
            },
            ...messages.map(e => ({
            value: e.messageId,
            label: e.messageName
            }))
        ]

        return (
            <PageBreak>
                <Row>
                    <Form
                        inputs={{
                            dailyDisplay: assignments.dailyPass.displayMessageId,
                            dailyReceipt: assignments.dailyPass.receiptMessageId,

                            fleetDisplay: assignments.fleetPass.displayMessageId,
                            fleetReceipt: assignments.fleetPass.receiptMessageId,

                            prepaidDisplay: assignments.prepaidPass.displayMessageId,
                            prepaidReceipt: assignments.prepaidPass.receiptMessageId,
                        }}

                        onSubmit={e => {
                            const putBack = {
                                dailyPass: {
                                    displayMessageId: e.dailyDisplay,
                                    receiptMessageId: e.dailyReceipt,
                                },
                                fleetPass: {
                                    displayMessageId: e.fleetDisplay,
                                    receiptMessageId: e.fleetReceipt,
                                },
                                prepaidPass: {
                                    displayMessageId: e.prepaidDisplay,
                                    receiptMessageId: e.prepaidReceipt,
                                },
                            }
                            return HamQuest.put(QuestRoute.expressPass.messageAssignments, { ...putBack })
                        }}
                        editable
                        roles={userRoles.editProducts}
                        style={{ width: '100%' }}
                    >
                        <Col>
                            <Heading>Daily Pass</Heading>
                            <Row>
                                <Select
                                    label='Receipt Footer'
                                    name='dailyDisplay'
                                    options={options}
                                />
                                <Select
                                    label='Kiosk Display'
                                    name='dailyReceipt'
                                    options={options}
                                />
                            </Row>
                        </Col>
                        <Col>
                            <Heading>Fleet Passes</Heading>
                            <Row>
                                <Select
                                    label='Receipt Footer'
                                    name='fleetDisplay'
                                    options={options}
                                />
                                <Select
                                    label='Kiosk Display'
                                    name='fleetReceipt'
                                    options={options}
                                />
                            </Row>
                        </Col>
                        <Col>
                            <Heading>Prepaid Passes</Heading>
                            <Row>
                                <Select
                                    label='Receipt Footer'
                                    name='prepaidDisplay'
                                    options={options}
                                />
                                <Select
                                    label='Kiosk Display'
                                    name='prepaidReceipt'
                                    options={options}
                                />
                            </Row>
                        </Col>
                    </Form>
                </Row>

                <PageBreak>

                    {messages.length ? messages.map((e, i) => (
                        <Col
                            key={`Messaging-${i}`}
                        >
                            <Form
                                inputs={{
                                    message: e.message,
                                    messageName: e.messageName
                                }}
                                onSubmit={(f) => HamQuest.put(QuestRoute.expressPass.message(e.messageId), f)
                                    .then(() => fetchMessages())}
                                editable
                                roles={userRoles.editProducts}
                            >
                                <Input
                                    name='messageName'
                                    label='Name'
                                    required
                                />
                                <TextArea
                                    label='Message'
                                    name='message'
                                    tags={['FirstName', 'LastName', 'FullName', 'PassProgram']}
                                    required
                                />
                                <Button
                                    roles={userRoles.editProducts}
                                    onClick={() => ModalFactory.confirmAndProcess({
                                        confirmation: {
                                            title: 'Are you sure?',
                                            body: 'Are you sure you want to delete this message?',
                                            type: 'warning',
                                        },
                                        promise: {
                                            title: 'Removing Message',
                                            callback: () => HamQuest.delete(QuestRoute.expressPass.message(e.messageId)).then(() => fetchMessages())
                                        },
                                        confirmed: {
                                            title: 'Message Deleted',
                                            type: 'success',
                                        }
                                    })}
                                    style={{ width: 'fit-content' }}
                                >Delete Message</Button>
                            </Form>
                        </Col>
                    )) : <div>Loading Messages<LoadingEllipsis /></div>}
                </PageBreak>
            </PageBreak >
        )
    }

    return (
        <FormSetting
            wrapper
            label='Messages'
            info='Add personalized messages on the pay station display and receipt (not available for Gold Line pay stations).'
            controls={[
                <Button roles={userRoles.editProducts} onClick={addNewMessage}>Add New Message</Button>
            ]}
        >
            {messages && assignments ? <Messages /> : <Loading />}
        </FormSetting>

    );
}

export default Messaging;
